export default __webpack_public_path__ + "static/media/no-disposal-gray.3ccb171f.svg";